<div class="activity-panel">

    <div class="activity-header">
        <span class="activity-header-icon" aria-hidden="true">
            <i class="ph-bold ph-clock-countdown icon-20"></i>
        </span>
        <h3 class="activity-header-title">Activity</h3>
        <p class="activity-header-subtitle">Everything Gable has proposed and done, waiting on you or already committed.</p>
    </div>

    <!-- ======================= Success banner ======================= -->
    <div class="success-banner"
         [class.is-error]="banner.variant === 'error'"
         *ngIf="successBanner as banner">
        <i class="ph-bold banner-icon"
           [class.ph-check-circle]="banner.variant === 'success'"
           [class.ph-warning-circle]="banner.variant === 'error'"></i>
        <span class="banner-msg">{{ banner.message }}</span>
        <button type="button"
                class="banner-view"
                *ngIf="banner.variant === 'success'"
                (click)="onBannerView()">View →</button>
        <button type="button"
                class="banner-close"
                aria-label="Dismiss"
                (click)="dismissBanner()">
            <i class="ph-bold ph-x"></i>
        </button>
    </div>

    <!-- ======================= Tasks (option B: long deliverables) ======================= -->
    <div class="tasks-section" *ngIf="tasks.length > 0">
        <div class="rev-header">
            <i class="ph-bold ph-list-checks"></i>
            <span class="rev-header-title">Tasks</span>
            <span class="spacer"></span>
        </div>
        <div class="task-row" *ngFor="let task of tasks; trackBy: trackByTaskKey">
            <app-gable-deliverable-card
                *ngIf="task.state === 'running'"
                [loading]="true"
                [loadingLabel]="task.title"
                [loadingHint]="task.slow ? 'Taking longer than usual — still working; it will appear here when ready.' : 'Running in the background — you can keep working.'">
            </app-gable-deliverable-card>

            <app-gable-deliverable-card
                *ngIf="task.state === 'ready'"
                [payload]="deliverablePayload(task)">
            </app-gable-deliverable-card>

            <div class="task-failed" *ngIf="task.state === 'failed'">
                <i class="ph-bold ph-warning-circle"></i>
                <span class="task-failed-msg">{{ task.error || 'This analysis could not be completed.' }}</span>
                <button type="button" class="task-dismiss" (click)="dismissTask(task)" aria-label="Dismiss">
                    <i class="ph-bold ph-x"></i>
                </button>
            </div>
        </div>
    </div>

    <!-- ======================= Needs your review ======================= -->
    <ng-container *ngIf="!queueEmpty">
        <div class="rev-header">
            <i class="ph-bold ph-info"></i>
            <span class="rev-header-title">Needs your review</span>
            <span class="spacer"></span>
            <span class="rev-waiting" *ngIf="waitingCount > 0">{{ waitingCount }} waiting</span>
        </div>

        <!-- Filter chips — directly under the heading, filtering queue + feed -->
        <div class="filters">
            <button *ngFor="let filter of visibleFilters; trackBy: trackByFilterKey"
                    type="button"
                    class="fchip"
                    [class.on]="activeFilter === filter.key"
                    [attr.aria-pressed]="activeFilter === filter.key"
                    (click)="setFilter(filter.key)">
                {{ filter.label }}
            </button>
        </div>
    </ng-container>

    <ng-container *ngIf="!queueEmpty; else queueEmptyTpl">
        <div *ngFor="let group of reviewGroups; trackBy: trackByGroupModule"
             class="rev-group">

            <!-- Module group header -->
            <div class="rev-group-hd">
                <i class="ph-bold rev-group-icon" [ngClass]="groupIcon(group)"></i>
                <span class="rev-group-name">{{ group.label }}</span>
                <span class="rev-group-count">{{ group.entries.length }}</span>
                <span class="spacer"></span>
                <!-- Approve all parked until the flow is ready (SD-9233) — machinery in onApproveAllClick stays wired.
                <button type="button"
                        class="btn-approve-all"
                        *ngIf="groupHasPendingTyped(group)"
                        [disabled]="approvingGroup !== null"
                        (click)="onApproveAllClick(group)">
                    <i class="ph-bold ph-checks"></i>
                    {{ approvingGroup === group.module
                        ? 'Approving…'
                        : confirmingApproveAllGroup === group.module
                            ? ('Confirm approve ' + approvableCount(group))
                            : 'Approve all' }}
                </button>
                -->

            </div>

            <div class="rev-items">
              <!-- ONE card per underlying record: a request with one suggestion and a
                   request with three look structurally identical. The suggestions are
                   arranged INSIDE the card by shape (single / composite / choose). -->
              <div *ngFor="let card of group.cards; trackBy: trackByCardKey"
                   class="rc"
                   [class.rc-open]="isCardExpanded(card)">

                <!-- Acted-on card: green result bar naming what happened -->
                <div class="rc-done" *ngIf="card.doneLabel; else liveCard">
                    <i class="ph-bold ph-check-circle"></i>
                    <span class="rc-done-msg">{{ card.doneLabel }}</span>
                </div>

                <ng-template #liveCard>

                    <!-- Legacy CRUD proposals: summary row + approve/reject -->
                    <div class="rev-row" *ngIf="card.shape === 'single' && card.primary.cardPayload === null; else typedCard">
                        <div class="domain-tile" [ngClass]="domainToneClass(card.primary.proposal.actionType)">
                            <i class="ph-bold" [ngClass]="domainIcon(card.primary.proposal.actionType)"></i>
                        </div>
                        <div class="rev-main">
                            <div class="rev-title">{{ card.primary.proposal.summary }}</div>
                            <!-- PMC portfolio rows carry the community the suggestion belongs to (SD-9074 wave 2). -->
                            <span class="pill pill-gray org-chip" *ngIf="card.primary.proposal.organizationName as orgName">{{ orgName }}</span>
                            <div class="rev-sub">Expires {{ card.primary.proposal.expiresAt | date:'shortTime' }}</div>

                            <div class="rev-acts" *ngIf="!card.primary.resolvedLabel">
                                <button type="button"
                                        class="btn-sm btn-primary"
                                        [disabled]="card.primary.busy"
                                        (click)="approveCrud(card.primary)">
                                    <i class="ph-bold ph-check"></i>
                                    Approve
                                </button>
                                <button type="button"
                                        class="btn-sm btn-secondary"
                                        [disabled]="card.primary.busy"
                                        (click)="rejectCrud(card.primary)">
                                    Reject
                                </button>
                            </div>

                            <div class="rev-resolved-note" *ngIf="card.primary.resolvedLabel">
                                <i class="ph-bold ph-check"></i>
                                {{ card.primary.resolvedLabel }} — done
                            </div>
                        </div>
                    </div>

                    <ng-template #typedCard>
                        <!-- Collapsed row: record identity · subject · relationship hint -->
                        <button type="button"
                                class="rc-head"
                                [attr.aria-expanded]="isCardExpanded(card)"
                                (click)="toggleCard(card)">
                            <div class="rc-main">
                                <div class="rc-title-row">
                                    <span class="rc-title">{{ card.title }}</span>
                                    <span class="rc-amount" *ngIf="card.shape === 'single' && entryAmount(card.primary) as amt">{{ amt }}</span>
                                </div>
                                <span class="pill pill-gray org-chip" *ngIf="card.primary.proposal.organizationName as orgName">{{ orgName }}</span>
                                <div class="rc-subject" *ngIf="card.subject">{{ card.subject }}</div>
                                <div class="rc-hint" *ngIf="card.hint">
                                    <i class="ph-bold ph-sparkle"></i>
                                    <span>{{ card.hint }}</span>
                                </div>
                            </div>
                            <i class="ph-bold ph-caret-right rc-caret"></i>
                        </button>

                        <div class="rc-body"
                             [class.rc-body-multi]="card.shape !== 'single'"
                             *ngIf="isCardExpanded(card)">

                            <!-- Single suggestion: the full action-preview card owns the body -->
                            <ng-container *ngIf="card.shape === 'single'; else multiBody">
                                <app-gable-action-preview-card [payload]="card.primary.cardPayload"
                                                               [hideHeaderSection]="true"
                                                               [viewerCapability]="card.primary.proposal.viewerCapability"
                                                               (confirm)="onCardConfirm(card.primary, $event)"
                                                               (cancel)="onCardCancel(card.primary, $event)"
                                                               (snooze)="onCardSnooze(card.primary, $event)"
                                                               (utilityAction)="onCardUtility(card.primary, $event)">
                                </app-gable-action-preview-card>
                            </ng-container>

                            <!-- Composite / choose: the card arranges the suggestions itself -->
                            <ng-template #multiBody>
                                <a class="rc-record-link" *ngIf="cardRoute(card) as route" [routerLink]="route">
                                    <i class="ph-bold ph-arrow-square-out"></i>
                                    Open the full request
                                </a>

                                <div class="rc-reason" *ngIf="cardReasoning(card) as why">
                                    <i class="ph-bold ph-sparkle"></i>
                                    <span>{{ why }}</span>
                                </div>

                                <ng-container *ngIf="card.shape === 'composite'">
                                    <div class="rc-section">
                                        <div class="rc-overline">The action</div>
                                        <div class="rc-action-box">
                                            <i class="ph-bold ph-check-circle"></i>
                                            <span>{{ entryTitle(card.primary) }}</span>
                                        </div>
                                        <div class="rc-consequence" *ngIf="mergeConsequence(card) as note">{{ note }}</div>
                                        <div class="rc-draft" *ngIf="entryDraft(card.primary) as draft">{{ draft }}</div>
                                    </div>

                                    <div class="rc-section" *ngIf="card.followUps.length">
                                        <div class="rc-overline">Also do</div>
                                        <div class="rc-followups">
                                            <div class="rc-check"
                                                 *ngFor="let fu of card.followUps; trackBy: trackByFollowUp"
                                                 (click)="toggleFollowUp(card, fu)">
                                                <span class="rc-checkbox" [class.on]="fu.checked">
                                                    <i class="ph-bold ph-check"></i>
                                                </span>
                                                <div class="rc-check-main">
                                                    <div class="rc-check-title">{{ entryTitle(fu.entry) }}</div>
                                                    <div class="rc-check-sub">{{ entryConsequence(fu.entry) }}</div>
                                                    <!-- Never ask someone to approve a message they cannot read. -->
                                                    <div class="rc-draft" *ngIf="entryDraft(fu.entry) as draft">{{ draft }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                                <div class="rc-options" *ngIf="card.shape === 'choose'">
                                    <div class="rc-option"
                                         *ngFor="let option of card.options; let first = first; trackBy: trackByProposalId"
                                         [class.on]="option.proposal.id === card.selectedOptionId"
                                         (click)="selectOption(card, option)">
                                        <span class="rc-radio" [class.on]="option.proposal.id === card.selectedOptionId">
                                            <span class="rc-radio-dot"></span>
                                        </span>
                                        <div class="rc-option-main">
                                            <div class="rc-option-head">
                                                <div class="rc-option-title">{{ entryTitle(option) }}</div>
                                                <span class="rc-suggested" *ngIf="first">Suggested</span>
                                            </div>
                                            <div class="rc-check-sub">{{ entryConsequence(option) }}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="rc-echo" *ngIf="card.shape === 'choose' && selectedOption(card) as sel">
                                    <i class="ph-bold ph-arrow-right"></i>
                                    <span>{{ entryConsequence(sel) }}</span>
                                </div>

                                <div class="rc-blocked" *ngIf="cardBlocked(card) as blocked">
                                    <i class="ph-bold ph-lock-simple"></i>
                                    <span>
                                        {{ blocked.reason }}
                                        <ng-container *ngIf="blocked.whoCan.length"> {{ blocked.whoCan.join(', ') }} can approve.</ng-container>
                                    </span>
                                </div>

                                <div class="rc-actions">
                                    <button type="button"
                                            class="btn-sm btn-primary"
                                            [disabled]="card.committing || cardBlocked(card) !== null || (card.shape === 'choose' && card.selectedOptionId === null)"
                                            (click)="commitCard(card)">
                                        <i class="ph-bold ph-check"></i>
                                        {{ card.committing ? 'Working…' : cardPrimaryLabel(card) }}
                                    </button>
                                    <button type="button"
                                            class="btn-sm btn-secondary"
                                            [disabled]="card.committing"
                                            (click)="skipCard(card)">Skip</button>
                                    <span class="spacer"></span>
                                    <button type="button"
                                            class="rc-snooze"
                                            [disabled]="card.committing"
                                            (click)="snoozeCard(card)">Snooze</button>
                                </div>
                            </ng-template>
                        </div>
                    </ng-template>
                </ng-template>
              </div>
            </div>
        </div>
    </ng-container>

    <ng-template #queueEmptyTpl>
        <div class="feed-card">
            <div class="queue-empty">
                <i class="ph-bold ph-check-circle"></i>
                <div class="empty-title">All caught up</div>
                <div class="empty-sub">Nothing needs you right now — new suggestions will appear here.</div>
            </div>
        </div>
    </ng-template>

    <!-- Feed load failure — distinct from the empty state, with a retry. -->
    <div class="feed-card" *ngIf="feedError">
        <div class="queue-empty neutral">
            <i class="ph-bold ph-warning-circle"></i>
            <div class="empty-title">Couldn't load activity</div>
            <div class="empty-sub">Something went wrong fetching the feed.</div>
            <button type="button" class="btn-sm btn-secondary" (click)="retryFeed()">Retry</button>
        </div>
    </div>

    <!-- ======================= Module-grouped feed ======================= -->
    <!-- No empty state on purpose: decided actions only earn screen space once they exist. -->
    <ng-container *ngIf="feedDays.length">
        <ng-container *ngFor="let day of feedDays; trackBy: trackByDayLabel">
            <div class="feed-grp">{{ day.label }}</div>
            <div class="feed-card">
                <div *ngFor="let item of day.items; trackBy: trackByItemId"
                     class="feed-item">
                    <div class="domain-tile" [ngClass]="domainToneClass(item.actionType)">
                        <i class="ph-bold" [ngClass]="domainIcon(item.actionType)"></i>
                    </div>
                    <div class="feed-main">
                        <div class="feed-title">{{ item.summary }}</div>
                        <span class="pill pill-gray org-chip" *ngIf="item.organizationName as orgName">{{ orgName }}</span>
                        <div class="feed-meta">{{ decidedTime(item) }}</div>
                        <div class="feed-reason" *ngIf="dismissReasonLabel(item) as reason">
                            Reason: {{ reason }}
                        </div>
                    </div>
                    <div class="feed-side">
                        <span class="pill" [ngClass]="statusPillClass(item)">
                            {{ statusLabel(item) }}
                        </span>
                    </div>
                </div>
            </div>
        </ng-container>

        <div class="feed-more" *ngIf="canLoadMore">
            <button type="button"
                    class="btn-sm btn-secondary"
                    [disabled]="feedLoading"
                    (click)="loadMore()">
                {{ feedLoading ? 'Loading…' : 'Load more' }}
            </button>
        </div>
    </ng-container>

</div>
